import { useParams } from 'react-router-dom'

import { SearchOffersGeneral } from './search_offers_general'
import { SearchOffersByDay } from './search_offers_by_day'

export const SearchOffers = () => {
  const { serviceTypeName = '' } = useParams()

  return serviceTypeName === 'daycare' ? <SearchOffersByDay /> : <SearchOffersGeneral />
}
